<script setup lang="ts">
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { type Question } from '@providers/support/Question/Question';
import SupportBillQuestion from '@components/ui/support/SupportBillQuestion.vue';
const { questions } = defineProps<{ questions: Question[] }>();
const emit = defineEmits<{
    select: [Question];
    submit: [];
}>();

const onSelect = (question: Question) => {
    if (question.isLink()) {
        window.open(question.link);
    } else {
        emit('select', question);
    }
};
</script>

<template>
    <div class="questions">
        <div
            v-for="question in questions"
            :key="question.title"
            class="support-question-item"
            @click="onSelect(question)"
        >
            <mr-input
                v-if="question.isEditable()"
                :model-value="question.value"
                :label="question.title"
                :hide-description="question.isValid"
                :required="question.isRequired"
                :invalid="!question.isValid"
                error-text="مقدار وارد شده معتبر نمی باشد."
                @update:model-value="
                    val => question.updateValue(val?.toString() ?? '')
                "
                @submit="emit('submit')"
            />
            <SupportBillQuestion v-else-if="question.isBill()" :question />
            <div v-else class="title-container">
                <mr-typography weight="500" color="var(--gray-900)">
                    {{ question.title }}
                </mr-typography>
                <mr-typography
                    v-if="question.subTitle"
                    weight="500"
                    color="var(--cool-gray-600)"
                    size="small"
                >
                    {{ question.subTitle }}
                </mr-typography>
            </div>
            <mr-icon
                v-if="!question.isEditable()"
                :icon="faChevronLeft"
                color="var(--gray-900)"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.support-question-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding-block: 12px;
    border-bottom: 1px solid usePalette($p-gray, $p-400);
    width: 100%;
    cursor: pointer;
    .title-container {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
}
</style>
